import {
  GET_ERRORS,
  CLEAR_ERRORS,
  POSTING_LOADING,
  CLEAR_LOADING,
  GET_BINDINGS,
  GET_BINDINGS_FAIL,
  GET_REVIEWS,
  GET_DISPUTE,
  APPLY_BINDING,
  CANCEL_BINDING,
  GET_RETRIEVE_LAST,
  GET_BINDING,
  RETRIEVE_ACCOUNT,
} from './types';

import axios from 'axios';

export const postLoading = () => {
  return {
    type: POSTING_LOADING,
  };
};
export const clearLoading = () => {
  return {
    type: CLEAR_LOADING,
  };
};

export const getBindings = () => (dispatch) => {
  
  axios.get('/api/bind/get_bindings')
    .then((res) => {
      dispatch({
        type: GET_BINDINGS,
        payload: res.data,
      });
    })
    .catch((err) => {
      dispatch(clearLoading());
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data,
      });
    });
};

export const getBindingsFail = () => (dispatch) => {
  
  axios.get('/api/bind/get_bindings_fail')
    .then((res) => {
      dispatch({
        type: GET_BINDINGS_FAIL,
        payload: res.data,
      });
    })
    .catch((err) => {
      dispatch(clearLoading());
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data,
      });
    });
};

export const getReviews = () => (dispatch) => {
  
  axios.get('/api/bind/get_reviews')
    .then((res) => {
      dispatch({
        type: GET_REVIEWS,
        payload: res.data,
      });
    })
    .catch((err) => {
      dispatch(clearLoading());
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data,
      });
    });
};

export const getDispute = () => (dispatch) => {
  
  axios.get('/api/bind/get_dispute')
    .then((res) => {
      dispatch({
        type: GET_DISPUTE,
        payload: res.data,
      });
    })
    .catch((err) => {
      dispatch(clearLoading());
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data,
      });
    });
};

export const applyBinding = (data) => (dispatch) => {
  dispatch(postLoading());
  dispatch(clearErrors());
  
  axios
    .post('/api/bind/apply_binding', data)
    .then((res) => {
      dispatch({
        type: APPLY_BINDING,
        payload: res.data,
      });
    })
    .catch((err) => {
      dispatch(clearLoading());
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data,
      });
    });
};

export const cancelBinding = (data) => (dispatch) => {
  dispatch(postLoading());
  dispatch(clearErrors());
  
  axios
    .post('/api/bind/cancel_binding', data)
    .then((res) => {
      dispatch({
        type: CANCEL_BINDING,
        payload: res.data,
      });
    })
    .catch((err) => {
      dispatch(clearLoading());
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data,
      });
    });
};

export const getRetrieveLast = role_id => dispatch => {

  axios.get(`/api/bind/get_retrieve_last/${role_id}`)
    .then((res) => {
      dispatch({
        type: GET_RETRIEVE_LAST,
        payload: res.data,
      });
    })
    .catch((err) => {
      dispatch(clearLoading());
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data,
      });
    });
};

export const getBinding = role_id => dispatch => {

  axios.get(`/api/bind/get_binding/${role_id}`)
    .then((res) => {
      dispatch({
        type: GET_BINDING,
        payload: res.data,
      });
    })
    .catch((err) => {
      dispatch(clearLoading());
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data,
      });
    });
};

export const retrieveAccount = (data) => (dispatch) => {
  dispatch(postLoading());
  dispatch(clearErrors());
  
  axios
    .post('/api/bind/retrieve_account', data)
    .then((res) => {
      dispatch({
        type: RETRIEVE_ACCOUNT,
        payload: res.data,
      });
    })
    .catch((err) => {
      dispatch(clearLoading());
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data,
      });
    });
};

export const clearErrors = () => {
  return {
    type: CLEAR_ERRORS,
  };
};
